//import { STAGING_BASE_URL } from "./variables";

/**
 * API function to get EVV-enabled service IDs for a specific business
 * @param {string|number} businessId - Business ID to get EVV-enabled services for
 */
export const getExportableServiceIds = async (businessId) => {
  try {
    if (!businessId) {
      console.warn('No businessId provided to getExportableServiceIds');
      return { data: [] };
    }

    const response = await fetch(`https://api.ankota.net/fms/get-exportable-service-ids?businessId=${businessId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjE1MzAxMCwiYnVzaW5lc3NJZCI6MTA0NzAsIk1lbWJlcklEIjoxNDU3MTcsInVzZXJuYW1lIjoic2VjdXJlLmFkbWluIiwiZmlyc3ROYW1lIjoiU3VwcG9ydCIsImxhc3ROYW1lIjoiQW5rb3RhIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.fJaUKmFT1cv_AP-FGX-I8tBArpzMD5DF9l3-zqHY6aU'
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching exportable service IDs:', error);
    throw error;
  }
};

export default getExportableServiceIds;
